/* eslint-disable no-unused-vars */
import React, { useCallback, useMemo, useState } from "react"; // Removed unused useEffect
import { useSelector } from "react-redux";
import { IconButton, Tooltip } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useHistory } from "react-router-dom";
import Table from "../../components/Table/Table";
import { Header } from "../../components";
import { TicketStatusBaseColums } from "../../utils/utils";
import TicketButton from "../../components/TableComponents/TicketButton/TicketButton";
import TableLayout from "../../layouts/TableLayout/TableLayout";
import useTicketData from "../../hooks/useTicketData";
import useTicketFilters from "../../utils/ticketFilters";
import DocumentViewerModal from "../../components/DocumentViewerModal/DocumentViewerModal";
import useDocumentViewer from "../../hooks/useDocumentViewer";
import useTicketExport from "../../hooks/useTicketExport";
import ActionButtons from "../../components/TableComponents/ActionButtons/ActionButtons";
import { ROUTES } from "../../constants";
import NoItemsFound from "../../components/NoItemsFound/NoItemsFound";
import { VIEW_TYPE } from "../../utils/ticketUtils";

function TicketStatus() {
  const history = useHistory();
  const [ticketStatus, setTicketStatus] = useState("ALL");

  const {
    searchQuery,
    allRows:filteredRows,
    loading,
    isRefreshing,
    handleRefresh,
    handleSearchQuery,
    total,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    setPage
  } = useTicketData(ticketStatus, true, VIEW_TYPE.TICKET_STATUS);

  const {
    documentViewerModal,
    handleDownloadFile,
    handleViewDocument,
    handleCloseDocumentViewer,
  } = useDocumentViewer();

  const handleViewPhysicalDocument = useCallback(
    (ticketNumber, ticketCode) => {
      history.push(ROUTES.GOTOQUESTIONNAIRE(ticketNumber, ticketCode, ""));
    },
    [history]
  );

  const handleTicketStatusChange = useCallback(
    (status) => {
      setPage(0); 
      setTicketStatus(status);
    },
    [setPage]
  );

  const handleActionClick = useCallback(
    (action, rowData) => {
      if (action === "View Details") {
        handleViewPhysicalDocument(rowData.id, rowData.ticketNumber);
      }
    },
    [handleViewPhysicalDocument]
  );

  const columns = useMemo(() => {
    const updatedColumns = [...TicketStatusBaseColums];

    updatedColumns[0] = {
      width: 200,
      title: "Ticket Number",
      field: "ticketNumber",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => (
        <TicketButton
          ticketNumber={rowData.ticketNumber}
          ticketId={rowData.id}
        />
      ),
    };

    updatedColumns[4] = {
      width: 200,
      title: "Document",
      field: "document",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) =>
        rowData.physicalDocumentReceived ? (
          <div style={{ display: "flex", alignItems: "center", gap: "0.1rem" }}>
            <span style={{ marginRight: "0.1rem" }}>{rowData.document}</span>

            <Tooltip title="Download">
              <IconButton
                size="small"
                color="primary"
                onClick={() => {
                  handleDownloadFile(rowData.ticketNumber, "physically_verified");
                }}
              >
                <GetAppIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip title="View">
              <IconButton
                size="small"
                color="primary"
                onClick={() => {
                  handleViewDocument(rowData.ticketNumber, "", "physically_verified");
                }}
              >
                <VisibilityIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        ) : (
          <span style={{ marginRight: "0.1rem" }}>{rowData.document}</span>
        ),
    };

    updatedColumns[7] = {
      width: 165,
      title: "Time Stamp",
      field: "timeStamp",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => {
        const value = rowData.updatedOn;
        return (
          <div style={{ color: "#1F1F1F" }}>
            {value ? new Date(value).toLocaleString() : "Not Received"}
          </div>
        );
      },
    };

    // updatedColumns[5] = {
    //   width: 220,
    //   title: "Action",
    //   field: "action",
    //   enableSearch: false,
    //   enableFilter: false,
    //   render: (rowData) => (
    //     <ActionButtons
    //       actions={["View Details"]} // Set default actions for approver
    //       status={rowData.status}
    //       onActionClick={(action) => handleActionClick(action, rowData)}
    //     />
    //   ),
    // };

    return updatedColumns;
  }, [handleDownloadFile, handleViewDocument]);

  const { handleExport, isExporting } = useTicketExport(ticketStatus, columns,VIEW_TYPE.TICKET_STATUS);

  return (
    <TableLayout
      styles={{ tableInnerWrapper: { paddingBottom: "0rem" } }}
      header={
        <Header
          searchQuery={searchQuery}
          handleSearchQuery={handleSearchQuery}
          onRefresh={handleRefresh}
          isRefreshing={isRefreshing}
          onExport={handleExport}
          isExporting={isExporting}
          TicketStatus={ticketStatus}
          setTicketStatus={handleTicketStatusChange}
          disableExport={filteredRows.length === 0}
        />
      }
    >
      {filteredRows.length === 0 && !(loading) ? (
        <NoItemsFound />
      ) : (
        <Table
          columns={columns}
          defaultColumns={columns}
          rows={filteredRows}
          hideCheckbox
          rowHeight={45}
          setHasActiveEdits={() => {}}
          isDataLoading={loading || isRefreshing}
          serverSide
          totalRows={total}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}

      <DocumentViewerModal
        open={documentViewerModal.open}
        onClose={handleCloseDocumentViewer}
        documentUrl={documentViewerModal.documentUrl}
        documentName={documentViewerModal.documentName}
        documentType={documentViewerModal.documentType}
        isLoading={documentViewerModal.isLoading}
        error={documentViewerModal.error}
      />
    </TableLayout>
  );
}

export default TicketStatus;
